// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface ContentBookFavoriteStarIconSignature {
  Element: SVGSVGElement;
}

export const ContentBookFavoriteStarIcon: TOC<ContentBookFavoriteStarIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M11 18.001H6V2.00098H16V10.995H18V1.00098C18 0.448977 17.553 0.000976562 17 0.000976562H1C0.447 0.000976562 0 0.448977 0 1.00098V19.001C0 19.553 0.447 20.001 1 20.001H11V18.001ZM4 18.001H2V2.00098H4V18.001ZM19.714 16.287L18 12.001L16.285 16.287H12L15.708 19.417L13.714 24.001L18 21.167L22.285 24.001L20.292 19.417L24 16.287H19.714Z"/>
</svg>
</template>;